module.exports = __webpack_public_path__ + "img/camera_up.f5df6010.svg";